import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalVariable } from '../global';
import { ServerService } from '../providers/server.service';

@Component({
  selector: 'app-survey',
  templateUrl: './survey.page.html',
  styleUrls: ['./survey.page.scss'],
})
export class SurveyPage implements OnInit {

  constructor(
    private server:ServerService,
    public globals:GlobalVariable,
    private route:ActivatedRoute,
    private router:Router
  ) { 
  //  console.log( this.route.snapshot.params.event)
  }

  ngOnInit() {
    this.getSurveys();
  }

getSurveys(){
  this.server.getSurveyList().subscribe(res=>{
    console.log(res);
    if(res.success){
      this.globals.EventList=res.data

    }
  })
}
eventStart(event){
  let name
  name=event.event_name
  name = name.replace(/[^a-zA-Z ]/g, '');
  name = name.replace(/ /g, '-');
  name = name.replace(/--/g, '-');
this.router.navigateByUrl('event/'+name+'/'+event.event_id,{state:{event:event}})
  // this.router.navigateByUrl('event/'+'somename/'+2,{})

}
}
